import { useQuery } from '@tanstack/react-query';
import { quizService } from '../services/quiz.service';
import { crosswordService } from '../services/crossword.service';
import { wordSearchService } from '../services/word-search.service';
/**
 * Hook to fetch quiz submissions using TanStack Query
 */
export const useQuizSubmissions = (quizId) => {
    return useQuery({
        queryKey: ['quiz-submissions', quizId],
        queryFn: () => {
            if (!quizId)
                throw new Error('Quiz ID is required');
            return quizService.getSubmissions(quizId);
        },
        enabled: !!quizId,
    });
};
/**
 * Hook to fetch crossword submissions using TanStack Query
 */
export const useCrosswordSubmissions = (crosswordId) => {
    return useQuery({
        queryKey: ['crossword-submissions', crosswordId],
        queryFn: () => {
            if (!crosswordId)
                throw new Error('Crossword ID is required');
            return crosswordService.getSubmissions(crosswordId);
        },
        enabled: !!crosswordId,
    });
};
/**
 * Hook to fetch word search submissions using TanStack Query
 */
export const useWordSearchSubmissions = (wordSearchId) => {
    return useQuery({
        queryKey: ['wordSearch-submissions', wordSearchId],
        queryFn: () => {
            if (!wordSearchId)
                throw new Error('Word Search ID is required');
            return wordSearchService.getSubmissions(wordSearchId);
        },
        enabled: !!wordSearchId,
    });
};
